const INITIAL_FIELD_STATE = {
  value: undefined,
  valid: false,
};

export { INITIAL_FIELD_STATE };
